import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TablePaginationExhibit1 as TablePagination } from "../../../common/table/table-pagination.component";
import { requestLogActions } from "./../../../../store/external/request-reducer/request-log.reducer";
import { requestDetailsActions } from "./../../../../store/external/request-reducer/request-details.reducer";
import { REQUEST_SUB_LINKS as RequestTable } from "../../../../constants/external-constants";
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import "./../request-page.component.css";

class OrderRequestCoverageTable extends Component {
    constructor(props) {
        super();
    }

    componentWillMount() {
        this.props.setActiveRequestTable(RequestTable.coverageRequest.id);
        this.props.fetchRequestLogItems(0, RequestTable.coverageRequest.id);
    }

    openRequestModal = (item) => {
        const { setSelectedRequest, history } = this.props;
        setSelectedRequest(item);
        history.push("CoverageRequest/RequestDetail/Order/" + item.OrderId);
    };

    render() {
        const { orderCoverageData, orderCoverageLoaded, orderCoverageFetchError, fetchRequestLogItems, fetchSortedRequestData } = this.props;

        return (
            <div>
                {
                    orderCoverageLoaded ?
                        orderCoverageFetchError ?
                            <span> Error in fetching data. </span> :
                            <TablePagination
                                id={RequestTable.coverageRequest.id}
                                columns={orderCoverageData.Headers}
                                pageList={orderCoverageData.Data.Items}
                                pages={orderCoverageData.Pagination}
                                rowClickAction={this.openRequestModal}
                                paginationAction={fetchRequestLogItems}
                                sortAction={fetchSortedRequestData}
                            /> :
                        <div>
                            <NoSubscription customClass="loading-page" title="Loading, Please Wait…" />
                        </div>
                }
            </div>
        );
    }
}

export default connect(
    state => {
        const { requestLog } = state;
        return {
            ...requestLog
        };
    },
    dispatch =>
        bindActionCreators(
            Object.assign({}, requestLogActions, requestDetailsActions),
            dispatch
        )
)(OrderRequestCoverageTable);
